import { type } from 'arktype';

import { stringMaxLength, stringRequiredAndMaxLength } from '@/schemas/utils';

export const addressSchema = type({
  street: type('string').narrow(stringRequiredAndMaxLength(70)),
  complement: type('string').narrow(stringMaxLength(16)),
  city: type('string').narrow(stringRequiredAndMaxLength(20)),
  state: type('string > 0 | null').configure({ message: 'VALIDATION_REQUIRED' }),
  zipCode: type('string > 0').configure({ message: 'VALIDATION_REQUIRED' }),
});

export const addressSchemaPartial = type({
  'address?': addressSchema,
});
